import ListPlatforms from "@/views/development/ListPlatforms.vue";

export default [
  {
    path: "/list_platforms",
    name: "list_platforms_path",
    component: ListPlatforms
  }
];